import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import classes from "./ActivityEditor.module.css";
import YuJaComboBox from "../../components/standardization/YuJaComboBox";
import {LTIApiCalls} from "../../apis/LTIApiCalls";
import {useGlobalFilter, usePagination, useTable} from "react-table";
import {Table} from "react-bootstrap";
import TableSortHeaderNew from "../../components/TableSortHeaderNew";
import {RadioGroup} from "@base-ui/react/radio-group";
import radioClasses from "../../components/standardization/YuJaRadioBox.module.css";
import {Radio} from "@base-ui/react/radio";
import NormalPagination from "../../components/pagination/NormalPagination";
import {ReactComponent as CLOSE} from "../../images/Close.svg"
import { ReactComponent as SearchIcon } from "../../images/search_bar_icon.svg";
import {ReactComponent as NoResultImage} from "../../images/no-result-found.svg";
import {ReactComponent as NO_QUIZZES_AVAILABLE} from "./images/no_quizzes_available_img.svg";
import YuJaButton from "../../components/standardization/YuJaButton";
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import {
    transformBlackboardQuestionsToEngage,
} from "../../utils/questionUtils";
import loadingJson from "../../animations/LoadingDots.json";
import Lottie from "react-lottie";
import QuestionAccordion from "./QuestionAccordion";
import {useSession} from "../../hooks/useSession";
import { useTranslation, Trans } from "react-i18next";


export default function ImportQuestionsBlackboard({
                                                  courseList,
                                                  selectedWorkflow,
                                                  draftActivity,
                                                  userSettings,
                                                  importedQuestions,
                                                  setImportedQuestions,
                                                  setIsSelectedImportItem
}) {
    const { t } = useTranslation();
    const tableRef = useRef();
    const {getSession} = useSession();
    const {courseId} = getSession();
    let copy = !!courseList ? JSON.parse(JSON.stringify(courseList)) : [];
    let sessionCourse = copy.filter(i => i.isLmsCourse).find(c => c.value === courseId);
    copy = copy.filter(i => i.isLmsCourse).map((item) => ({label: item.label, value: item.lmsCourseId}));
    let activeStep = selectedWorkflow.steps.find(s => !!s.active);

    const {listLMSQuizzes, listLMSQuizQuestions} = LTIApiCalls();
    const [selectedCourse, setSelectedCourse] = useState(
        sessionCourse
            ? sessionCourse.lmsCourseId
            : (copy.length > 0 ? copy[0].value : "")
    );
    const [courseOpts, setCourseOpts] = useState(copy);

    const [isQuizzesLoading, setIsQuizzesLoading] = useState(true);
    const [isQuizQuestionsLoading, setIsQuizQuestionsLoading] = useState(true);
    const [quizzes, setQuizzes] = useState([]);
    const [keyword, setKeyword] = useState("");
    const [sortedBy, setSortedBy] = useState("");
    const [selectedQuiz, setSelectedQuiz] = useState("");
    const [previousStateHeight, setPreviousStateHeight] = useState(0);
    const [fakePoll, setFakePoll] = useState(() => {
        let copy = JSON.parse(JSON.stringify(draftActivity));
        const {questions, ...rest} = copy;
        return {poll: rest, questions: []};
    });

    const LottieOptions = {
        loop: true,
        autoplay: true,
        animationData: loadingJson,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        }
    };


    useEffect(() => {
        if (!selectedCourse) {
            setIsQuizzesLoading(false);
            return;
        }
        setIsQuizzesLoading(true);
        listLMSQuizzes(selectedCourse).then((rawQuizzes) => {
            let quizzes = rawQuizzes.map(i => ({
                id: i.assessmentId,
                title: i.title,
            }));
           setQuizzes(quizzes);
            setSelectedQuiz(!!quizzes.length ? quizzes[0].id : "");
        }).finally(() => setIsQuizzesLoading(false));
    }, [selectedCourse]);

    useLayoutEffect(() => {
        if (tableRef.current) {
            const {height,} = tableRef.current.getBoundingClientRect();
            setPreviousStateHeight(height);
        }

    }, [selectedWorkflow]);


    // 1. Memoize your columns
    const columns = React.useMemo(() => [
        { Header: t("integration.blackboardTest"), accessor: "title", width: 450 },
        // { Header: QUIZ_TYPE, accessor: "quizType", width: 130, maxWidth: 250 },
    ], []);

    // 2. Memoize your filter function
    const filterCustomize = React.useMemo(() => (rows, _, filterValue) => {

        if (!filterValue || Object.entries(filterValue).length === 0) {
            return rows;
        }

        const filteredKeyword = filterValue.keyword ? filterValue.keyword.toLowerCase().trim() : "";
        return rows.filter(r => {
            const title = r.values.title;
            return title && title.toLowerCase().includes(filteredKeyword);
        });
    }, []);

    useEffect(() => {
        setGlobalFilter({keyword});
    }, [quizzes, keyword]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        state: { pageIndex},
        setGlobalFilter,
    } = useTable({
        columns,
        data: quizzes,
        initialState: { pageIndex: 0, pageSize: 6},
        autoResetPage: true,
        globalFilter: filterCustomize,
    }, useGlobalFilter, usePagination);

    useEffect(() => {
        // let find = quizzes.find(q => q.id === selectedQuiz);
        // if (!!find) {
        //     listLMSQuizQuestions(selectedCourse, selectedQuiz, find.quizType).then(questions => {
        //         let transferedQuestions = transformCanvasClassicQuizQuestionsToEngage(questions);
        //     })
        // }
        if (!!selectedQuiz) {
            setIsSelectedImportItem(true);
        } else {
            setIsSelectedImportItem(false);
            setImportedQuestions([]);
        }
    }, [selectedQuiz]);


    useEffect(() => {
        if (activeStep.isLast) {
            setIsQuizQuestionsLoading(true);
            listLMSQuizQuestions(selectedCourse, selectedQuiz).then(questions => {
                let convertedQuestions = transformBlackboardQuestionsToEngage(questions);
                let copy = JSON.parse(JSON.stringify(draftActivity));
                const {questions: qs, ...rest} = copy;
                setFakePoll({poll: rest, questions: JSON.parse(JSON.stringify(convertedQuestions))});
                setImportedQuestions(convertedQuestions.filter(q => q.questionType !== "UNSUPPORTED"));

            }).finally(() => setIsQuizQuestionsLoading(false));
        } else {
            setIsQuizQuestionsLoading(true);
        }
    }, [activeStep, selectedQuiz]);








    if (isQuizzesLoading) {
        return (
            <div
                className={classes.column}
                style={previousStateHeight ? {width: "100%", height: previousStateHeight} : {width: "100%", flex: 1}}
            >
                <div style={{flex: 1}}/>
                <Lottie
                    options={LottieOptions}
                    height={200}
                    style={{overflow: 'unset', width: 360, height: 300, cursor: "default", margin: 0, alignSelf: "center"}}
                    isClickToPauseDisabled={true}
                />
                <div className={classes.loadingTitle}>{t("questionBuilder.loadingTests")}</div>
                <div
                    className={classes.description}
                    style={{fontSize: 16, color: "#4A5565", textAlign: "center", marginTop: 12}}
                >{t("questionBuilder.loadingTestsDesc")}</div>
                <div style={{flex: 1}}/>
            </div>
        );
    }

    if (activeStep.isLast && isQuizQuestionsLoading) {
        return (
            <div
                className={classes.column}
                style={previousStateHeight ? {width: "100%", height: previousStateHeight} : {width: "100%", flex: 1}}
            >
                <div style={{flex: 1}}/>
                <Lottie
                    options={LottieOptions}
                    height={200}
                    style={{overflow: 'unset', width: 360, height: 300, cursor: "default", margin: 0, alignSelf: "center"}}
                    isClickToPauseDisabled={true}
                />
                <div className={classes.loadingTitle}>{t("questionBuilder.retrievingTestQuestions")}</div>
                <div
                    className={classes.description}
                    style={{fontSize: 16, color: "#4A5565", textAlign: "center", marginTop: 12}}
                >{t("questionBuilder.retrievingBlackboardQuestions")}</div>
                <div style={{flex: 1}}/>
            </div>
        );
    }

    if (activeStep.isLast) {
        return (
            <div className={classes.column} style={{width: "100%", flex: 1}} ref={tableRef}>
                {!fakePoll.questions.length &&
                    <div className={classes.column} style={{alignItems: "center", flex: 1}}>
                        <div style={{flex: 1}}/>
                        <NO_QUIZZES_AVAILABLE style={{height: 150, alignSelf: "center", margin: "20px 0"}}/>
                        <span style={{alignSelf: "center", fontSize: 20, fontWeight: "700", lineHeight: 1.4}}>
                            {t("questionBuilder.noQuestionsInQuiz")}
                        </span>
                        <span style={{alignSelf: "center", marginTop: 20}}>
                            {t("questionBuilder.noQuestionsInQuizDesc")}
                        </span>
                        <div style={{flex: 2}}/>
                    </div>
                }


                {!!fakePoll.questions.length &&
                    <>
                        <div className={classes.row} style={{ rowGap: 10, columnGap: 20, flexWrap: "wrap" }}>
                            <div className={classes.description} style={{flex: 1, minWidth: "min(100%, 365px)"}}>
                                <Trans
                                    i18nKey="questionBuilder.viewAllQuestionsFrom"
                                    values={{title: quizzes.find(q => q.id === selectedQuiz)?.title}}
                                    components={{bold: <strong/>}}
                                />
                            </div>
                            <div className={classes.badge} style={{minWidth: 140}}>
                                {importedQuestions.length}&nbsp;/&nbsp;{fakePoll.questions.length} {t("table.questionsHeader")}
                            </div>
                        </div>
                        <QuestionAccordion
                            fakePoll={fakePoll}
                            importedQuestions={importedQuestions}
                            setImportedQuestions={setImportedQuestions}
                        />
                    </>
                }
            </div>
        );
    }

    return (
        <div className={classes.column} style={{width: "100%", flex: 1}} ref={tableRef}>
            <div className={classes.description} style={{marginBottom: 25}}>
                {t("questionBuilder.selectBlackboardCourseDesc")}
            </div>

            <div className={classes.row} style={{columnGap: 30, rowGap: 10, flexWrap: 'wrap'}}>
                <div className={classes.column} style={{maxWidth: 280}}>
                    <div className={classes.title} id={"select_course_title"}>{t("questionBuilder.selectBlackboardCourse")}</div>
                    <div className={classes.description} style={{fontSize: 14}}>
                        {t("questionBuilder.selectBlackboardCourseHint")}
                    </div>
                </div>

                <YuJaComboBox
                    size={"small"}
                    value={selectedCourse}
                    options={courseOpts}
                    onChange={opt => {
                        setSelectedCourse(!!opt?.value ?  opt.value : "");
                        setSelectedQuiz("");
                        setKeyword("");
                    }}
                    aria-labelledby={"select_course_title"}
                    style={{flex: 1, minWidth: 200, maxWidth: 'min(600px, 100%)'}}
                    positionStyle={{zIndex: 1}}
                />
            </div>

            {/*{!!quizzes.length && quizzes.find(q => q.quizType === "new") &&*/}
            {/*    <div className={classes.banner} style={{marginTop: 15}}>*/}
            {/*        <div className={classes.iconWrapper}>*/}
            {/*            <InfoIcon/>*/}
            {/*        </div>*/}
            {/*        <div style={{flex:1, minWidth:200}}>*/}
            {/*            {"Some details for new Canvas quizzes may not be available. You can still import these quizzes and edit the information in Engage."}*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*}*/}


            {!quizzes.length &&
                <div className={classes.column} style={{flex: 1, minHeight: 250, alignItems: "center", justifyContent: "center" }}>
                    <NO_QUIZZES_AVAILABLE style={{height: 150, alignSelf: "center", margin: "20px 0"}}/>
                    <span style={{alignSelf: "center", fontSize: 20, fontWeight: "700", lineHeight: 1.4}}>
                    {t("questionBuilder.noTestsInCourse")}
                </span>
                    <span style={{alignSelf: "center", marginTop: 20}}>
                    {t("questionBuilder.noTestsInCourseDesc")}
                </span>
                </div>
            }



            {!!quizzes.length &&
                <div className={classes.CanvasTableWrapper} style={{marginTop: 15}}>
                    <YuJaTextBox
                        containerStyle={{
                            height: 40,
                            minWidth: 100,
                            maxWidth: 500,
                            fontSize: 14,
                            lineHeight: 1.6,
                            margin: "10px 20px",
                            marginBottom: 10,
                        }}
                        onChange={e => setKeyword(e.target.value)}
                        value={keyword}
                        before={<SearchIcon style={{marginRight: 5, width: 16}}/>}
                        after={
                            !!keyword
                                ? (
                                    <YuJaButton
                                        style={{width: 24, height: 24}}
                                        aria-label={t("accessibility.clearSearchKeyword")}
                                        iconOnly={true}
                                        onClick={() => setKeyword("")}
                                    >
                                        <CLOSE style={{width: 18, height: 18}}/>
                                    </YuJaButton>
                                )
                                : (<></>)
                        }
                        placeholder={t("questionBuilder.searchByTestName")}
                    />
                    <Table {...getTableProps()}>
                        <thead>
                            {headerGroups.map((headerGroup, index) => (
                                <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column, idx) => (
                                        <TableSortHeaderNew
                                            key={idx}
                                            data={quizzes}
                                            setData={setQuizzes}
                                            sortedBy={sortedBy}
                                            setSortedBy={setSortedBy}
                                            propertyName={column.id}
                                            label={column.Header}
                                            {...column.getHeaderProps({
                                                style: {
                                                    width: column.width,
                                                    minWidth: column.minWidth,
                                                    maxWidth: column.maxWidth,
                                                    textAlign: 'left',
                                                    paddingLeft: idx === 0 ? 45 : undefined
                                                }
                                            })}
                                        >
                                            {column.Header}
                                        </TableSortHeaderNew>
                                    ))}
                                </tr>
                            ))}
                        </thead>

                        <RadioGroup
                            value={selectedQuiz ?? ""}
                            onValueChange={(val, e) => {
                                setSelectedQuiz(val);
                            }}
                            {...getTableBodyProps()}
                            render={(props) => <tbody {...props}></tbody>}
                        >
                            {!page.length &&
                                <tr>
                                    <td colSpan={1}>
                                        <div className={classes.column} style={{flex: 1, padding: "20px 0", justifyContent: "center"}}>
                                            <div className={classes.column} style={{alignItems: "center"}}>
                                                <NoResultImage style={{height: 150, alignSelf: "center", margin: "20px 0"}}/>
                                                <span style={{alignSelf: "center", fontSize: 20, fontWeight: "700", lineHeight: 1.4}}>
                                                        {t("questionBuilder.noMatchingTests")}
                                                    </span>
                                                <span style={{alignSelf: "center", marginTop: 20}}>
                                                        {t("questionBuilder.noMatchingTestsDesc")}
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            }
                            {page.map((row, index) => {
                                prepareRow(row);
                                return (
                                    <tr key={index}{...row.getRowProps()}>
                                        {row.cells.map((cell, cellIdx) => {
                                            return (
                                                <td key={cellIdx}>
                                                    <div className={classes.row} style={{width: "100%"}}>
                                                        <label
                                                            title={!!cell.value ? cell.value : ""}
                                                            className={radioClasses.Item}
                                                            style={{gap: 8, padding: "5px 0 5px 12px", flex: 1, minWidth: 100}}
                                                        >
                                                            <Radio.Root value={row.original.id} nativeButton={true} className={radioClasses.Radio}>
                                                                <Radio.Indicator className={radioClasses.Indicator} keepMounted={true}/>
                                                            </Radio.Root>
                                                            <span
                                                                style={{
                                                                    flex: "0 1 auto",
                                                                    minWidth: 0,
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    display: "inline-block",
                                                                }}
                                                            >
                                                                    {!cell.value ? "-" : cell.value}
                                                                </span>

                                                        </label>
                                                    </div>

                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </RadioGroup>
                    </Table>
                </div>
            }


            {pageCount > 1 &&
                <NormalPagination
                    pageCount={pageCount}
                    pageIndex={pageIndex}
                    pageOptions={pageOptions}
                    canPreviousPage={canPreviousPage}
                    canNextPage={canNextPage}
                    previousPage={previousPage}
                    nextPage={nextPage}
                    gotoPage={gotoPage}
                />
            }


        </div>
    );
}